module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.handleClose),
      expression: "handleClose"
    }],
    staticClass: "vm-select"
  }, [(_vm.multiple) ? _c('div', {
    ref: "tags",
    staticClass: "vm-select__tags",
    style: ({
      'max-width': _vm.inputWidth - 32 + 'px'
    }),
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleMenu($event)
      }
    }
  }, [_c('transition-group', {
    on: {
      "after-leave": _vm.resetInputHeight
    }
  }, _vm._l((_vm.selected), function(item) {
    return _c('vm-tag', {
      key: item.value,
      attrs: {
        "closable": true,
        "hit": item.hitState,
        "type": "primary",
        "close-transition": ""
      },
      on: {
        "close": function($event) {
          _vm.deleteTag($event, item)
        }
      }
    }, [_c('span', {
      staticClass: "vm-select__tags-text"
    }, [_vm._v(_vm._s(item.currentLabel))])])
  })), _vm._v(" "), (_vm.filterable) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    ref: "input",
    staticClass: "vm-select__input",
    style: ({
      width: _vm.inputLength + 'px',
      'max-width': _vm.inputWidth - 42 + 'px',
      height: _vm.inputheight + 'px'
    }),
    attrs: {
      "type": "text",
      "disabled": _vm.disabled,
      "debounce": _vm.remote ? 300 : 0
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "focus": function($event) {
        _vm.visible = true
      },
      "keyup": _vm.managePlaceholder,
      "keydown": [_vm.resetInputState, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        $event.preventDefault();
        _vm.navigateOptions('next')
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        $event.preventDefault();
        _vm.navigateOptions('prev')
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.selectOption($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        _vm.visible = false
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46])) { return null; }
        _vm.deletePrevTag($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('vm-input', {
    ref: "reference",
    attrs: {
      "type": "text",
      "placeholder": _vm.currentPlaceholder,
      "name": _vm.name,
      "inputclass": (_vm.inputclass + " vm-select-input__inner"),
      "disabled": _vm.disabled,
      "readonly": !_vm.filterable || _vm.multiple,
      "validate-event": false,
      "icon": _vm.iconClass
    },
    on: {
      "focus": _vm.handleFocus,
      "click": _vm.handleIconClick
    },
    nativeOn: {
      "mousedown": function($event) {
        _vm.handleMouseDown($event)
      },
      "keyup": function($event) {
        _vm.debouncedOnInputChange($event)
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        $event.preventDefault();
        _vm.navigateOptions('next')
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        $event.preventDefault();
        _vm.navigateOptions('prev')
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.selectOption($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        $event.stopPropagation();
        $event.preventDefault();
        _vm.visible = false
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.visible = false
      }],
      "paste": function($event) {
        _vm.debouncedOnInputChange($event)
      },
      "mouseenter": function($event) {
        _vm.inputHovering = true
      },
      "mouseleave": function($event) {
        _vm.inputHovering = false
      }
    },
    model: {
      value: (_vm.selectedLabel),
      callback: function($$v) {
        _vm.selectedLabel = $$v
      },
      expression: "selectedLabel"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "vm-zoom-in-top"
    },
    on: {
      "after-leave": _vm.doDestroy,
      "after-enter": _vm.handleMenuEnter
    }
  }, [_c('vm-select-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible && _vm.emptyText !== false),
      expression: "visible && emptyText !== false"
    }],
    ref: "popper"
  }, [_c('vm-scrollbar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.options.length > 0 && !_vm.loading),
      expression: "options.length > 0 && !loading"
    }],
    class: {
      'is-empty': !_vm.allowCreate && _vm.filteredOptionsCount === 0
    },
    attrs: {
      "tag": "ul",
      "wrap-class": "vm-select-dropdown__wrap",
      "view-class": "vm-select-dropdown__list"
    }
  }, [(_vm.showNewOption) ? _c('vm-option', {
    attrs: {
      "value": _vm.query,
      "created": ""
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), (_vm.emptyText && (_vm.allowCreate && _vm.options.length === 0 || !_vm.allowCreate)) ? _c('p', {
    staticClass: "vm-select-dropdown__empty"
  }, [_vm._v(_vm._s(_vm.emptyText))]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e9b7105","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Select.vue
// module id = 38
// module chunks = 0